import React, { useState } from "react";
import Button from '@mui/material/Button';
import PatientAction from "./patientActionButtons";
const DiagnosisInformation = () => {
    const getUserValue = JSON.parse(sessionStorage.getItem("loginDetails"))
    const intitalState = {
        diagnosisName: "",
        followup: "",
        doctorName: "",
        referredBy: "",
        consulatation: "",
        followup: "",
        CreatedBy: getUserValue?.uniqueID
    }
    const [diagnosisInfoInputFields, setdiagnosisInfoInputFields] = useState(intitalState);



    const handleDiagnosisInputChange = (event) => {
        const { name, value } = event?.target;
        setdiagnosisInfoInputFields((prevState) => {
            return {
                ...prevState,
                [name]: value,
            };
        });
    }

    const handleDiagnosis = (e) => {
        e?.preventDefault();
        
    }
    return (
        <>
            <PatientAction />
            <div className="diagnosis">
                <form>
                    <div className="diagnosis-info">
                        <div className="mt-3 ml-3"> <h4>Diagnosis Information</h4></div>
                        <div className="row" style={{ marginLefy: 0, marginRight: 0 }}>
                            <div className="form-group col-md-6">
                                <label for="fname" className="control-label col-sm">Diagnosis</label>
                                <div className="col-sm">
                                    <input type="text" className="form-control" id="fname"
                                        name="diagnosisName"
                                        value={diagnosisInfoInputFields?.diagnosisName}
                                        onChange={handleDiagnosisInputChange} required
                                        placeholder="Diagnosis" />
                                </div>
                            </div>
                            <div className="form-group col-md-6">
                                <label for="lname" className="control-label col-sm">Doctor</label>
                                <div className="col-sm">
                                    <input type="text" className="form-control" id="lname" placeholder="Doctor"
                                        name="doctorName"
                                        value={diagnosisInfoInputFields?.doctorName}
                                        onChange={handleDiagnosisInputChange} required
                                    />
                                </div>
                            </div>
                            <div className="form-group col-md-6">
                                <label for="fname" className="control-label col-sm">Referred By</label>
                                <div className="col-sm">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="fname"
                                        placeholder="Referred By"
                                        name="referredBy"
                                        value={diagnosisInfoInputFields?.referredBy}
                                        onChange={handleDiagnosisInputChange} required
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="address-infor p-2">
                        <div className="mt-3 ml-3"> <h4>Visit Type </h4></div>
                        <div className="row mt-2" style={{ marginLefy: 0, marginRight: 0 }}>
                            <div className="form-group col-md-6">
                                <label for="lname" className="control-label col-sm">Consulatation</label>
                                <div className="col-sm">
                                    <input type="text" className="form-control" id="lname" placeholder="Consulatation"
                                        name="consulatation"
                                        value={diagnosisInfoInputFields?.Consulatation}
                                        onChange={handleDiagnosisInputChange} required />
                                </div>
                            </div>
                            <div className="form-group col-md-6">
                                <label for="lname" className="control-label col-sm">Followup</label>
                                <div className="col-sm">
                                    <input type="text" className="form-control" id="lname" placeholder="Followup"
                                        name="followup"
                                        value={diagnosisInfoInputFields?.Followup}
                                        onChange={handleDiagnosisInputChange} required
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-end mr-3 mb-3">
                        <Button variant="outlined" onClick={(e) => handleDiagnosis(e)}>Submit</Button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default DiagnosisInformation; 